import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
// import 'semantic-ui-css/semantic.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'izitoast/dist/css/iziToast.css';
import 'vue-datetime/dist/vue-datetime.css';
import 'vue-search-select/dist/VueSearchSelect.css'
import './assets/css/uv_virtualKeyboard.css'
import selectDepartment from './components/MainComponents/SelectedDepartment.vue';
import Uv_virtualKeyboard from './helpers/uv_virtualKeyboard.js';
import vuCalendar from 'simple-vue-calendar-uv'
// import SuiVue from 'semantic-ui-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Datetime from 'vue-datetime';
import tabs from 'simple-vue-tabs';
import VueIziToast from "vue-izitoast";
import PGSHelper from './helpers/PGSHelper.js';
import Alert from './helpers/alert.js';
import LenguajeHelper from './helpers/lenguajeHelper.js';
import vuetify from '@/vuetify/vuetify'
import DBHandler from './helpers/database/handler';
import _ from 'lodash';
import JsonExcel from "vue-json-excel";
import Maska from 'maska'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import { VueMaskDirective } from 'v-mask'
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Column2D from 'fusioncharts/fusioncharts.charts';
import PowerCharts from 'fusioncharts/fusioncharts.powercharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import Currencies from './clases/Currencies.js'
import './assets/css/PGS.css'
Vue.config.productionTip = false;
Vue.use(VueFusionCharts, FusionCharts, Column2D, PowerCharts, FusionTheme);
Vue.directive('mask', VueMaskDirective);
Vue.config.productionTip = false
Vue.use(vuCalendar)
// Vue.use(SuiVue)
Vue.component(selectDepartment);
Vue.component("downloadExcel", JsonExcel);
Vue.use(VueSweetalert2);
Vue.use(tabs);
Vue.use(VueIziToast);
Vue.use(Datetime);
//Vue.use(Maska)

var pgsHelper = new PGSHelper(new Vue);
var AlertWrapper = new Alert();
var Lhelper = new LenguajeHelper(new Vue);
var uvKeyboard = new Uv_virtualKeyboard(Vue);

Vue.component('selectDepartment',
  () => import('./components/MainComponents/SelectedDepartment.vue')
)
Vue.component('ModuleHeader',
  () => import('./components/MainComponents/GlobalComponent/Headers/ModuleHeader.vue')
)
Vue.component('Modal',
  () => import('./components/MainComponents/modal.vue')
)
const isDevelopment = process.env.NODE_ENV !== 'production'
if (!isDevelopment) {
  Sentry.init({
    Vue,
    dsn: "https://3125005e13d441f390eb996d7c54af5b@o1357850.ingest.sentry.io/6644587",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["admin.pargolfsolutions.com", /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}



Object.defineProperty(Vue.prototype, '$Currencies', { value: Currencies })
Object.defineProperty(Vue.prototype, '$t', { value: Lhelper.t })
Object.defineProperty(Vue.prototype, '$pgsHelper', { value: pgsHelper, });
Object.defineProperty(Vue.prototype, '$alert', { value: AlertWrapper, });
Object.defineProperty(Vue.prototype, '$uvVirtualKeyboard', { value: uvKeyboard });
Object.defineProperty(Vue.prototype, '$dbHandler', { value: new DBHandler("pdvDB") });
Object.defineProperty(Vue.prototype, '$_', { value: _ });
Object.defineProperty(Vue.prototype, '$firebaseApp', {
  get: function () {
    if (Vue.$store) {
      if (Vue.$store.state) {
        if (Vue.$store.state.FirebaseApp) {
          if (Vue.$store.state.FirebaseApp.firebaseApp) {
            return Vue.$store.state.FirebaseApp.firebaseApp;
          }
        }
      }
    }

    return undefined
  },
});
new Vue({
  vuetify,
  router,
  store,
  Maska,
  render: h => h(App),
}).$mount('#app')
